import { useQuery } from '@tanstack/react-query';

import Api from '@/services/api';
import { OWAS_QUERY_KEYS } from '../enums';
import type { BaseContext } from '@/types';

type GetOwasFrameResultRequest = BaseContext & {
	report_id: string;
	frame_id: string;
	file_id: string;
};

type GetOwasFrameResultResponse = {
	code: string;
	score: number;
};

async function getScore(params: GetOwasFrameResultRequest): Promise<GetOwasFrameResultResponse> {
	const url = `/ergonomic-tool/owas/report/${params.report_id}/frame/${params.frame_id}`;
	const { data } = await Api.get<GetOwasFrameResultResponse>(url, { params });
	return data;
}

export const useGetOwasFrameResult = (params: GetOwasFrameResultRequest) => {
	return useQuery([OWAS_QUERY_KEYS.GET_RESULT, params], () => getScore(params));
};
